import axios from '@axios'
import { storePagination, sorting } from '@/mixins'
// import moment from 'moment'

const getInitialState = () => ({
  ...storePagination.state(),
  sorting: {
    sortBy: 'createdDate',
    sortDesc: true,
  },
  stockInversions: [],
  filters: {
    storeId: null,
    skuFromId: null,
    skuToId: null,
    from: null,
    to: null,
    period: {
      startDate: null, // moment().startOf('day').format(),
      endDate: null, // moment().endOf('day').format(),
    },
  },
})

export default {
  namespaced: true,
  state: getInitialState(),

  getters: {},

  mutations: {
    ...storePagination.mutations,

    SET_STOCK_INVERSIONS(state, stockInversions) {
      state.stockInversions = stockInversions
    },
    SET_FILTERS(state, filters) {
      state.filters = filters
    },
    CLEAN_FILTERS(state) {
      const { filters } = getInitialState()
      state.filters = filters
    },
    CLEAN_STATE(state) {
      const { filters, paging, stockInversions } = getInitialState()
      state.filters = filters
      state.stockInversions = stockInversions
      state.paging = paging
    },
  },

  actions: {
    ...storePagination.actions,

    async fetchStockInversions({ commit, state }) {
      const { startDate, endDate } = state.filters.period

      const { data } = await axios.get('/api/stock-inversions', {
        params: {
          storeId: state.filters.storeId,
          skuFromId: state.filters.skuFromId,
          skuToId: state.filters.skuToId,
          from: startDate,
          to: endDate,
          pageSize: state.paging.pageSize,
          pageIndex: state.paging.currentPage - 1,
          sortBy: sorting.methods.getSorting(state),
        },
      })

      commit('SET_STOCK_INVERSIONS', data.results || [])
      commit('SET_PAGING', {
        ...state.paging,
        rowCount: data.rowCount || 0,
        rowsInCurrentPage: data.rowsInCurrentPage || 0,
      })
    },

    resetFilters({ commit }) {
      commit('CLEAN_FILTERS')
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
